import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation } from 'react-router';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SessionModel } from '../../models/SessionModel';
import { ApplicationState } from '../../store';
import { ServiceContractMaintScheduleList, ServiceContractMaintScheduleModel } from '../../models/ServiceContractMaintScheduleModel';
import * as ServContScheduleStore from '../../store/ServiceContractMaintSchedule';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect } from 'react';

type MyProps =
    { MaintenanceScheduleList: ServiceContractMaintScheduleList } & { SessionState: SessionModel } & typeof ServContScheduleStore.actionCreators;

const ServiceContractMaintenanceScreen: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const location = useLocation();

    useEffect(() => {
        const contractNumber = location.state.contractNumber;
        props.loadServiceContractSchedule(contractNumber);
    }, []); 

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.MaintenanceScheduleList.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            <Col>
                {props.MaintenanceScheduleList.items.map((item, index) =>                    
                    <Row key={index}>                        
                        <ServiceContractMaintenanceCard item={item}></ServiceContractMaintenanceCard>
                    </Row>
                )}
            </Col>
        </Container>
        );
    }

type ServiceContractMaintenanceCardProp = {
    item: ServiceContractMaintScheduleModel
}

const ServiceContractMaintenanceCard: React.FunctionComponent<ServiceContractMaintenanceCardProp> = (props: ServiceContractMaintenanceCardProp) => {

    return (<Card className='service-contract-maint-card'>
        
        <CardBody>
            <Row>
                <Col xs={6} sm={3}>
                    <SaLabel Text={"Task"} />  {props.item.taskDescription}
                </Col>
                <Col xs={6} sm={3}>
                    <SaLabel Text={"Due Date"} /> <SaDate Value={props.item.scheduleDate} />
                </Col>              
                <Col xs={6} sm={3}>
                    <SaLabel Text={"Maint Done"} />  {props.item.maintenanceDone?"Yes":"No"}
                </Col>
                <Col xs={6} sm={3}>
                    <SaLabel Text={"WO#"} />
                    {props.item.callNumber > 0 &&  props.item.callNumber}
                </Col>              
            </Row>        
            <Row>
                <Col xs={12}>
                    <SaLabel Text={"Description"} /> {props.item.maintenanceDescription} 
                </Col>
                </Row>
        </CardBody>
        { props.item.allowToBookCall &&
            <CardFooter>
            <Row>
                <Col xs={12} style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <Link to={{
                        pathname: "/BookMaintenance", state: {
                            taskNum: props.item.taskNum,
                            startDateRange: props.item.startDateRange,
                            endDateRange: props.item.endDateRange,
                            taskDescription: props.item.taskDescription,
                            maintenanceDescription: props.item.maintenanceDescription,
                            contractNumber: props.item.contractNumber,
                            contractSequence: props.item.contractSequence
                        }
                    }}><Button size="sm">Book Call</Button></Link>
                </Col>
            </Row>
            </CardFooter>

        }
    </Card>);
}

export default connect(
    (state: ApplicationState) => ({ ...{ MaintenanceScheduleList: state.serviceContractMaintScheduleState }, ...{ SessionState: state.sessionState } }),
    ServContScheduleStore.actionCreators)(ServiceContractMaintenanceScreen as any);
